"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConsentPreferences = void 0;
const react_1 = require("@nanostores/react");
const store_1 = require("./store");
const useConsentPreferences = () => (0, react_1.useStore)(store_1.$consentPreferences);
exports.useConsentPreferences = useConsentPreferences;
